<template>
  <div
    class="view">
    <HomeNavigation />

    <div
      class="content"
      @drop.self="dropHandler($event, collectionNodes['0'])">
      <div
        class="collections-header">
        <div class="collections-header-left">
          <div class="collections-header-name">
            Manage your collections
          </div>
        </div>
      </div>

      <div class="collection-management-list-header">
        <div>Actions</div>
        <div>Collections</div>
      </div>
      <div class="no-collections" v-if="allCollections.length === 0">
        No collections found! Create a new collection via the 'plus' button below.
      </div>
      <CollectionManagementItem
        :collections="allCollections"
        :isRoot="true" />
    </div>

    <div
      class="add-button"
      @click="addNewCollection(0)">
      <i class="mdi mdi-plus mdi-36px" />
    </div>

  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CollectionManagementItem from '@/components/AppView/Settings/CollectionManagementItem.vue';
import HomeNavigation from '@/components/AppView/HomeNavigation.vue';

export default {
  name: 'CollectionManagement',
  components: {
    CollectionManagementItem,
    HomeNavigation,
  },
  computed: {
    ...mapState({
      collectionNodes: state => state.collections.collectionNodes,
      archivedCollectionNodes: state => state.collections.archivedCollectionNodes,
      selectedCollection: state => state.collections.selectedCollection,
      userId: state => state.users.internalUserId,
    }),
    allCollections() {
      return this.collectionNodes['0'] && this.collectionNodes['0'].children;
    },
  },
  methods: {
    ...mapActions({
      vMoveCollection: 'collections/moveCollection',
      addCollection: 'collections/addCollection',
    }),
    ...mapMutations({
      setHighlightDragOverCollection: 'appState/SetHighlightDragOverCollection',
      setMovingCollection: 'appState/SetMovingCollection',
    }),
    dropHandler(event, collection) {
      this.setHighlightDragOverCollection(null);
      const { id: newParentId } = collection;
      this.vMoveCollection({ newParentId, collectionId: this.movingCollection });
      this.setMovingCollection(null);
    },
    addNewCollection(parentId) {
      this.$buefy.dialog.prompt({
        message: 'Enter a name for the collection',
        trapFocus: true,
        onConfirm: (name) => {
          const newCollection = {
            name,
            notes: [],
          };
          const newMembership = {
            parentCollectionId: parentId,
            relatedUserId: this.userId,
            collectionAccessLevel: 1,
          };
          this.addCollection({ newCollection, newMembership });
          this.showAddChildFor = null;
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';
@import '~styles/layouts';

.root-container {
  overflow-y: scroll;
  height: calc(100vh - 2.875rem - 1.5rem); // minus navigation and top bar thingy
  padding-top: 2rem;
}
.container {
  max-width: none !important;
}
.view {
  position: relative;
  height: 100vh;
  max-height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.collection-tabs {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  z-index: 5;
  border-bottom: 1px solid $primary;
  font-size: 1.25rem;
  height: 2.875rem; // (font-size * 1.5 line-height) + 0.5 padding + 1px for border
  padding: 0 0 0 0;
  vertical-align: middle;
}
.collection-tab {
  flex: 0 0 auto;
  margin: 0 0 -1px 0;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
}
.collection-tab-active {
  font-weight: 600;
}
.content {
  position: relative;
}
.collection-management-list-header {
  position: relative;
  top: 1rem;
  border-bottom: 1px solid $primary;
  font-family: $headerFont;
  font-size: 0.8rem;
  background: #ffffff;
  z-index: 1;
}
.collection-management-list-header div {
  display: inline-block;
}
.collection-management-list-header div:first-child {
  width: 11rem;
  padding-left: 2.5rem;
}
.collections-header {
  position: sticky;
  top: 10px;
  display: flex;
  width: 100%;
  padding: 0.125rem;
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  height: 1.5rem;
  font-size: 0.7rem;
  color: rgba($black, 0.75);
  background-color: rgba($primary, 0.25);
  user-select: none;
}
.collections-header div {
  display: inline-flex;
}
.collections-header-name {
  padding-left: 0.25rem;
}
.collections-header-left {
  flex-basis: 50%;
  display: flex;
  padding-left: 2rem;
}
.no-collections {
  padding: 1.5rem 1rem;
  font-size: 0.8rem;
  font-style: italic;
}
.add-button {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  height: 3rem;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  box-shadow: 0.5px 0.5px 2px 1px $primary;
  border-radius: 50%;
  background-color: $secondary-dark;
  z-index: 5;
  cursor: pointer;
  transition: opacity 0.3s;
}
</style>
